<div class="p-3">
    <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
</div>
<div class="row">
    <div class="col-12 p-0 mt-2 d-flex">
        <div [ngClass]="activeTab === 'maling-address' ? 'col-4 tabNewSub p-2 activeNewTimeLine' : 'col-4 tabNewSub p-2'"
            (click)="toggleMode('maling-address')">
            <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon>Mailing Address<mat-icon
                        *ngIf="activeTab === 'maling-address'">keyboard_arrow_down</mat-icon></a>
            </div>
        </div>
        <div [ngClass]="activeTab === 'fee-claculation' ? 'col-4 tabNewSub p-2 activeNewTimeLine' : 'col-4 tabNewSub p-2'"
            (click)="toggleMode('fee-claculation')">
            <div class="newAlignTab lbl-text align-tabs">
                <a><mat-icon>assignment</mat-icon> Fee Calculation <mat-icon
                        *ngIf="activeTab === 'fee-claculation'">keyboard_arrow_down</mat-icon></a>
            </div>
        </div>
        <div [ngClass]="activeTab === 'processing-information' ? 'col-4 tabNewSub p-2 activeNewTimeLine' : 'col-4 tabNewSub p-2'"
            (click)="toggleMode('processing-information')">
            <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon> Processing Information <mat-icon
                        *ngIf="activeTab === 'processing-information'">keyboard_arrow_down</mat-icon></a>
            </div>
        </div>
        <!-- <div [ngClass]="activeTab === 'generate-forms' ? 'col-3 tabNewSub p-2 activeNewTimeLine' : 'col-3 tabNewSub p-2'"
            (click)="toggleMode('generate-forms')">
            <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon> Generate Forms <mat-icon
                        *ngIf="activeTab === 'generate-forms'">keyboard_arrow_down</mat-icon></a>
            </div>
        </div> -->
    </div>
    <div class="col-12 p-0 my-3" *ngIf="activeTab === 'maling-address'  && inputData?.taskId">
        <mailing-address-library [primaryDataWizard]="inputData" [isWizard]="true"></mailing-address-library>
    </div>
    <div class="col-12 p-0 my-3" *ngIf="activeTab === 'fee-claculation' && inputData?.taskId">
        <fee-calculation-library [primaryData]="inputData" [isWizard]="true"></fee-calculation-library>
    </div>
    <div class="col-12 p-0 my-3" *ngIf="activeTab === 'processing-information'  && inputData?.taskId">
        <consulate-address-library [primaryData]="inputData" [isWizard]="true"></consulate-address-library>
    </div>
    <!-- <div class="col-12 p-0 my-3" *ngIf="activeTab === 'generate-forms'  && inputData?.taskId">
        <generate-forms-library [primaryData]="inputData" [isWizard]="true"></generate-forms-library>
    </div> -->
</div>